import { Role } from "app/auth/role";
import { RoleDto } from "app/dal/generated/models/security/role-dto";
import { RoleName } from "app/dal/generated/models/security/role-name";
import { TenantDto } from "app/dal/generated/models/security/tenant-dto";
import { UserDto } from "app/dal/generated/models/security/user-dto";
import { FeaturePermission } from "./feature-permission";

export class User {
    public id: string;
    public username: string;
    public displayName: string | null;
    public isGlobalAdmin: boolean;
    public tenantAndRoles: {
        tenant: TenantDto;
        roles: Roles;
    }[];

    public constructor(user: UserDto) {
        this.id = user.id;
        this.username = user.username;
        this.displayName = user.displayName;
        this.isGlobalAdmin = user.isGlobalAdmin;
        this.tenantAndRoles = user.tenantRoles.map((tr) => ({
            tenant: tr,
            roles: new Roles(tr.roles),
        }));
    }

    public getAccessibleTenants() {
        return this.tenantAndRoles.map((t) => t.tenant);
    }

    public getAccessibleTenantByAbbreviation(abbreviation: string) {
        return this.tenantAndRoles.find((e) => e.tenant.abbreviation === abbreviation)?.tenant;
    }

    public getImpliedTenantRolesByAbbreviation(abbreviation: string) {
        // Ensure global admin first to match ClaimsPrincipalExtensions logic
        if (this.isGlobalAdmin) {
            return new Roles([new Role({ id: "", name: RoleName.Administrator })]);
        }

        const tr = this.tenantAndRoles.find((e) => e.tenant.abbreviation === abbreviation);
        if (tr) {
            return tr.roles;
        } else {
            return new Roles([]);
        }
    }
}

export class Roles {
    roles: Role[];

    public constructor(roles: RoleDto[]) {
        this.roles = roles.map((r) => new Role(r));
    }

    public hasPermission(permission: FeaturePermission) {
        return this.roles.some((r) => {
            return r.permissions.includes(permission);
        });
    }
}
